import { Capacitor } from '@capacitor/core';

const FORCE_NATIVE_DEV_KEY = 'wa:forceNative';

function getForceNativeFlag(): boolean {
  // if (!import.meta.env.DEV) return false;
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(FORCE_NATIVE_DEV_KEY) === 'true';
  } catch {
    return false;
  }
}

export function isCapacitorApp(): boolean {
  if (getForceNativeFlag()) return true;
  return Boolean(Capacitor.getPlatform && Capacitor.getPlatform() !== 'web');
}
